import { useContext } from "react";
import { ReactReduxContext } from "react-redux";
import { organizacjeActions } from "../store/actions/organizacje.actions";
import { IDRaksStore } from "../store/store";
import { NOT_SELECTED_ID, OrganizacjaWidok } from "../store/types/organizacje";
import createHistory from "history/createBrowserHistory";
import { organizacjeService } from "../services/organizacje.service";

function useWybranaOrganizacja() {
  const { store } = useContext(ReactReduxContext);
  const { dispatch } = store;

  const zmienWybrana = (id: string) => {
    organizacjeService.przegladaj().then((lista: OrganizacjaWidok[]) => {
      const organizacja = lista.find((x) => x.Id === id);
      if (organizacja) {
        dispatch(organizacjeActions.zmienWybrana(organizacja));
      }
    });
  };

  const wybierzPierwszaOrganizacje = (lista: OrganizacjaWidok[]) => {
    let organizacja = {} as OrganizacjaWidok;
    if (lista && lista.length > 0) organizacja = lista[0];
    dispatch(organizacjeActions.zmienWybrana(organizacja));
    const id = organizacja.Id || NOT_SELECTED_ID;
    const history = createHistory();
    history.push(`/${id}/organizacje`);
  };

  const idWybranej =
    (store.getState() as IDRaksStore).organizacje.wybrana.Id || NOT_SELECTED_ID;

  return { zmienWybrana, wybierzPierwszaOrganizacje, idWybranej };
}

export default useWybranaOrganizacja;
